import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { PropertyStopSaleState } from '../../../../../../types/properties/propertyTypes';
import DotIcon from '../../../../../components/DotIcon';
import Menu from '../../../../components/Menu';
import { TAX_DATE_TAG_COLOR } from '../../../../../../utils/taxes/taxesListUtils';
import {
    categorizePeriod,
    formatDate,
} from '../../../../../../utils/formatDates';
import Tag from '../../../../../../muiComponents/Tag';
import routes from '../../../../../../utils/commonVariables/routes';
import encodeBase64 from '../../../../../../utils/encodeBase64';

interface PropertyStopSalesRowProps {
    item: PropertyStopSaleState;
}
const PropertyStopSalesRow = ({ item }: PropertyStopSalesRowProps) => {
    const tagText = categorizePeriod(item.fromDate, item.toDate);

    return (
        <TableRow key={item.id}>
            <TableCell>
                <div
                    className='flex-center'
                    style={{ minWidth: 50, maxWidth: 50 }}
                >
                    <DotIcon truthy={item.enabled} />
                </div>
            </TableCell>
            <TableCell>{item.room}</TableCell>
            <TableCell>{item.ratePlan}</TableCell>
            <TableCell>{item.mealPlan}</TableCell>
            <TableCell style={{ minWidth: '120px', maxWidth: '130px' }}>
                <div className='flex-column flex-align-end gap-10 height100perc flex-between'>
                    {formatDate(item.fromDate)} - {formatDate(item.toDate)}
                    <Tag text={tagText} color={TAX_DATE_TAG_COLOR[tagText]} />
                </div>
            </TableCell>
            <TableCell style={{ minWidth: 50, maxWidth: 50 }}>
                <Menu
                    menuItems={[
                        {
                            text: 'go_to_stop_sale_detail',
                            icon: 'OpenInNew',
                            onClick: () => {
                                const route = `${routes.landingPrivate}${
                                    routes.stopSales
                                }?id=${encodeBase64(item.id)}`;
                                window.open(route, route);
                            },
                        },
                    ]}
                />
            </TableCell>
        </TableRow>
    );
};

export default PropertyStopSalesRow;
